
            const data = {"name":"feather/eye","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z\"/><circle pid=\"1\" cx=\"12\" cy=\"12\" r=\"3\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                